// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"j1","bridgingOfferParagraph":"j2","bridgingOfferHeading":"j3"};